import React, { useEffect, useState } from "react";
import Layouts from "../../Components/Layouts/Layouts.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Eventdetails.css";
import { useParams } from "react-router-dom";
import { environment } from "../../environment";
import axios from "../../axiosinstens";
import { Modal, Button, Form } from "react-bootstrap"; // Bootstrap Modal
import { Helmet } from "react-helmet-async";
function Eventdtils() {
  const { id } = useParams();
  const [event, setEvent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const getEvents = async () => {
    try {
      const response = await axios.get("getSeminar");
      const eventsData = response.data.seminar;
      const singleEvent = eventsData.find(
        (e) => e.event_id === id || e._id === id
      );
      setEvent(singleEvent);
    } catch (error) {
      console.error("Error fetching events", error);
    }
  };

  const openModal = (img) => {
    setSelectedImage(img);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalIsOpen(false);
  };

  useEffect(() => {
    getEvents();
  }, []);

  const to12HourFormat = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(+hour);
    date.setMinutes(+minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleEnrollClick = () => {
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!email) return alert("Please enter your email");

    setSubmitting(true);

    try {
      await axios.post("submit-email", {
        seminar_id: event._id,
        email: email,
        url: event.booking_url,
      });
      setShowModal(false);
      setEmail("");
      window.open(event.booking_url, "_blank");
    } catch (error) {
      console.error("Enrollment failed:", error);
      alert("Enrollment failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <Helmet>
  <title>
    {event?.name} | Martial Arts Event Details
  </title>

  <meta
    name="description"
    content={`${event?.name} - View event details, date, location, instructor information, pricing, and registration details for this martial arts seminar or training event.`}
  />

  <meta
    name="keywords"
    content={`${event?.name}, martial arts event, martial arts seminar, karate seminar, taekwondo event, MMA training, self defense workshop, martial arts tournament`}
  />
</Helmet>
      <Layouts>
        <div className="evnsam">
          <section className="evnsam_container">
            <div className="evntsdtlssec">
              <div className="evn">
                <h1>{event.name}</h1>
                <hr />
              </div>
              <figure className="figure">
                <img
                  src={`${environment.imageBaseURL}seminar/${event.image}`}
                  alt=""
                />
              </figure>

              <figure className="figure">
                {event.promotionalImages &&
                  event.promotionalImages.length > 0 &&
                  event.promotionalImages.map((img, index) => (
                    <img
                      key={index}
                      src={`${environment.imageBaseURL}seminar/${img}`}
                      alt={`Promotional ${index + 1}`}
                      style={{
                        width: "160px",
                        margin: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => openModal(img)}
                    />
                  ))}
              </figure>

              <Modal
                show={modalIsOpen}
                onHide={() => closeModal()}
                centered
                style={{
                  content: {
                    maxWidth: "500px",
                    margin: "auto",
                    padding: "10px",
                    textAlign: "center",
                  },
                }}
              >
                {selectedImage && (
                  <img
                    src={`${environment.imageBaseURL}seminar/${selectedImage}`}
                    alt="Full Image"
                    style={{ width: "100%", height: "auto" }}
                  />
                )}
                <button
                  onClick={closeModal}
                  style={{
                    margin: "10px",
                    width: "10%", // % must be in quotes
                    background: "red", // value must be in quotes
                    border: "none",
                    color: "white",
                    display: "block",
                    marginLeft: "auto", // camelCase
                    marginRight: "auto",
                  }}
                >
                  Close
                </button>
              </Modal>

              {event.about_seminar && (
                <>
                  <p>
                    <b>About the seminar :</b>
                  </p>
                  <p>
                    {event.about_seminar.split("\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                </>
              )}

              {event?.about_presenter && (
                <>
                  <p>
                    <b>About the presenter(s):</b>
                  </p>
                  <p>
                    {event.about_presenter.split("\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                </>
              )}

              {event.event_type === "physical_events" && event.address && (
                <p>
                  <b>Physical Address :</b> {event.address}
                </p>
              )}
              {event.event_type === "online_event" && (
                <p>
                  <b>Online Event</b>
                </p>
              )}

              {event.eventDuration == "less" && event.start_date && (
                <div className="containttime d-flex gap-4">
                  <p>
                    <span>Seminar date:</span>
                    {event.times && (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(5, 1fr)",
                          gap: "10px",
                          marginTop: "10px",
                        }}
                      >
                        {Object.entries(event.times).map(
                          ([date, time], index) => (
                            <div
                              key={index}
                              style={{
                                border: "1px solid #ccc",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "left",
                              }}
                            >
                              <b>Date:</b> {date}
                              <br />
                              <b>Time:</b> {to12HourFormat(time.start)} -{" "}
                              {to12HourFormat(time.end)}
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </p>
                </div>
              )}

              {event.eventDuration == "more" && event.start_date && (
                <div className="containttime d-flex gap-4">
                  <p>
                    <span>Seminar date:</span>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {event.timings_morethen && (
                        <div
                          style={{
                            border: "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "5px",
                            textAlign: "left",
                          }}
                        >
                          <b>Date:</b> {event.start_date} To {event.end_date}
                          <br />
                          <b>Time:</b> {event.timings_morethen}
                        </div>
                      )}
                    </div>
                  </p>
                </div>
              )}

              {event?.event_price && (
                <p>
                  <b>Seminar/Event fee :</b> {event?.settings?.currency_symbol}
                  {parseFloat(event?.event_price).toFixed(2)}
                </p>
              )}

              <div className="viewall">
                <button onClick={handleEnrollClick} className="btn enroll">
                  {event?.plan_id?._id === "68749ca7633fc221dea68c97"
                    ? "Video Payment Landing Page"
                    : "Enroll Here"}
                </button>
              </div>
            </div>
          </section>
        </div>

        {/* Email Entry Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Enter Your Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowModal(false);
                setEmail("");
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={submitting}
              className="btn enroll"
            >
              {submitting ? "Submitting..." : "Submit & Proceed"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Layouts>
    </>
  );
}

export default Eventdtils;
